import { useMutation } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback, useMemo } from 'react';
import { createQrCode } from '@shared/api/mutations/export';
import { Loadable } from '@shared/components/loading';
import { API } from '@shared/types/api';
import { CreateRemoteQrCode } from '../types';

export function useCreateRemoteQrCode(): CreateRemoteQrCode {
  const [create, { loading, data, error }] = useMutation<
    API.CreateQrCodeMutation,
    API.CreateQrCodeMutationVariables
  >(createQrCode);

  const createRemoteQrCode = useCallback(
    (url: string) => create({ variables: { input: { url } } }),
    [create],
  );

  const response: Loadable<string> | undefined = useMemo(() => {
    if (loading) {
      return { state: 'loading' };
    } else if (!isNil(data)) {
      return { state: 'success', data: data.createQrCode };
    } else if (!isNil(error)) {
      return { state: 'failure', error: error };
    } else {
      return undefined;
    }
  }, [loading, data, error]);

  return { response, createRemoteQrCode };
}
